var root = require('./window-or-global');
var store;
var nativeCallHandlers = [];

function initNativeCalls(_store, _nativeCallHandlers) {
  if (!Array.isArray(_nativeCallHandlers)) throw new Error('Invalid Function Array.');
  store = _store;
  nativeCallHandlers = _nativeCallHandlers;
}

function callJavaScript(message) {
  var payload;
  try {
    payload = JSON.parse(message);
  } catch(e) {
    throw new Error('Invalid JSON received from a native call: ' + message);
  }

  nativeCallHandlers.forEach(function(fn) {
    fn(payload, store);
  });
}

root.callJavaScript = callJavaScript;

function callNative(action) {
  var stringifiedAction = JSON.stringify(action);
  if (root.webkit) {
    root.webkit.messageHandlers.callNative.postMessage(stringifiedAction);
  } else if (root.Android) {
    root.Android.callNative(stringifiedAction);
  }
}

module.exports = {
  initNativeCalls: initNativeCalls,
  callNative: callNative
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ifit/native-webview-interface/index.js
// module id = 165
// module chunks = 0